import type { LoyaltyAllowedMatrixDtoList } from "src/app/features/LoyaltyAllowedMatrix/types/LoyaltyAllowedMatrixDtoList";
import type { LoyaltyAllowedMatrixEntityList } from "src/app/features/LoyaltyAllowedMatrix/types/LoyaltyAllowedMatrixEntityList";

export const LoyaltyAllowedMatrixEntityToDto = ({ ...rest }: Readonly<LoyaltyAllowedMatrixEntityList>): LoyaltyAllowedMatrixDtoList => {
    const newLoyaltyAllowedMatrixs = rest.loyaltyAllowedMatrixs?.map(
        ({ rowId: _rowId, ...loyaltyAllowedMatrixs }) => loyaltyAllowedMatrixs,
    );
    return { loyaltyAllowedMatrixs: newLoyaltyAllowedMatrixs };
};
